<template>
  <div class="audio-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="sort" label="排序" width="100"> </el-table-column>
      <el-table-column prop="name" label="路灯编组名称"> </el-table-column>
      <el-table-column prop="desc" label="路灯编组说明"> </el-table-column>
      <el-table-column prop="light" label="组亮度控制">
        <template slot-scope="scope">
          <span>{{ scope.row.light }}</span>
          <i
            class="el-icon-setting pointer mar-l5"
            @click="showSet(scope.row)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="管理路灯">
        <template slot-scope="scope">
          <span @click="openDeviceData(scope.row)" class="my-icon-button">管理路灯</span>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="140px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="编组名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
            <el-input v-model="editOne.sort"></el-input>
          </el-form-item>
          <el-form-item label="是否新协议">
            <el-switch
              v-model="editOne.is_new"
              inactive-text="否"
              active-text="是"
              :inactive-value="0"
              :active-value="1"
              inactive-color="gray"
            ></el-switch>
          </el-form-item>
          <el-form-item v-if="editOne.is_new" label="设置订阅分组主体">
            <el-input v-model="editOne.topic"></el-input>
          </el-form-item>
          <el-form-item label="编组说明" prop="desc">
            <el-input v-model="editOne.desc"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!--管理路灯-->
    <el-dialog
      :title="'['+deviceData.name+']管理路灯'"
      :visible.sync="deviceData.dialogVisible"
      v-if="deviceData.dialogVisible"
    >
      <device-list
        :groupId="deviceData.id"
        ref="deviceData"
        @closeMethod="closeDeviceData"
      ></device-list>
    </el-dialog>

    <el-dialog
      class="dialog600" 
      :title="'设置分组下所有路灯的亮度['+setBox.name+']'"
      :visible.sync="setBox.dialogVisible"
      v-if="setBox.dialogVisible">
      <div class="box_body">
        <el-slider
          v-model="setBox.light"
          :min="1"
          :max="100"
          show-input
        ></el-slider>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setBox.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="(setBox.dialogVisible = false), zuContorl()"
          >确 定</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import lightGroupApi from "@/api/light/lampGroup";
import deviceList from "@/components/light/lampGroup/deviceList.vue";
export default {
  components: {
    deviceList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      groupSelect: [],
      editOneRule: {
        name: [{ required: true, message: "请输入编组名称", trigger: "blur" }],
      },
      editType: -1,
      editOne: {},
      sendVisible: false,
      sendData: {
        group: null,
        group_name: ''
      },
      deviceData:{
        id: null,
        name: '',
        dialogVisible: false
      },
      setBox: {
        id: null,
        name: '',
        light: 0,
        dialogVisible: false
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightGroupApi.lightGroupList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);

        }
      });
    },
    
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          desc: '',
          is_new: '',
          topic: '',
          sort: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          desc: index.desc,
          is_new: index.is_new,
          topic: index.topic,
          sort: index.sort
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      if(this.editOne.is_new){
        let z_reg = /^[A-Za-z0-9/]+$/
        if (!z_reg.test(this.editOne.topic)) {
          return this.$message.error('您设置的订阅分组主体错误！');
        }
      }

      lightGroupApi.lightGroupEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    createItem() {
      if(this.editOne.is_new){
        let z_reg = /^[A-Za-z0-9/]+$/
        if (!z_reg.test(this.editOne.topic)) {
          return this.$message.error('您设置的订阅分组主体错误！');
        }
      }
      lightGroupApi.lightGroupAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lightGroupApi.lightGroupDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    openSend(value) {
      let sendParams = { 
        group: value.id,
        group_name: value.name
      }
      this.sendVisible = true
      this.sendData = sendParams
    },
    closeSend() {
      this.sendVisible = false
      this.sendData = {
        group: null,
        group_name: ''
      }
      this.getTableData(this.pageInfo.page);
    },

    openDeviceData(value) {
      let newParams = { 
        id: value.id,
        name: value.name,
        dialogVisible: true
      }
      this.deviceData = newParams
    },
    closeDeviceData() {
      this.deviceData = {
        id: null,
        name: '',
        dialogVisible: false
      }
    },
    showSet(index) {
      this.setBox = {
        id: index.id,
        name: index.name,
        light: index.light,
        dialogVisible: true
      }
    },
    zuContorl () {
      let sendData = {
        light: this.setBox.light
      }
      lightGroupApi.groupControl(this.setBox.id,sendData).then(res => {
        if (res.data.code === 1000) {
          this.$message.success('下发成功')
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less' scoped>
.audio-content {
  width: 100%;
}
.map-container {
  padding-left: 100px;
  height: 180px;
  margin-bottom: 10px;
}
.blue{
  cursor: pointer;
}
</style>